class FlashMessage {
  constructor(options) {
    this.type = options.type;
    this.message = options.message;
  }

  flashMessageTemplate() {
    return `
      <div style="z-index: 999999999999" data-cy="alert-message" data-cs-capture class="alert alert-${this.type} pl-4 py-3 flex items-center justify-between in" data-controller="flash-message">
        <div>
          ${this.message}
        </div>
        <div class="alert-close w-7 self-stretch flex items-center justify-center" data-action="click->flash-message#hideFlashMessage">
          <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 8.618L18.332.286a.977.977 0 0 1 1.382 1.382L11.382 10l8.332 8.332a.977.977 0 0 1-1.382 1.382L10 11.382l-8.332 8.332a.977.977 0 0 1-1.382-1.382L8.618 10 .286 1.668A.977.977 0 1 1 1.668.286L10 8.618z" fill="currentColor" fill-rule="evenodd"/>
          </svg>
        </div>
      </div>
    `;
  }

  call() {
    const div = document.createElement("div");
    div.innerHTML = this.flashMessageTemplate();
    document.body.appendChild(div);
  }
}

export default FlashMessage;
